import {
  ACCESS_POLICY_EFFECT,
  AccessPolicyStatement,
  AccessPolicyConditionEvaluator,
} from './types';

/**
 * To determine whether access to a resource is granted, two steps are applied:
 * A statement is applicable if all custom conditions evaluate to true
 *
 * Allow or deny:
 *  - The request is allowed if any of the statements have an effect of "allow",
 *    and none have an effect of "deny".
 *  - By default, all requests are denied.
 *  - Requests are implicitly denied if no `"allow"` statements are found, and
 *  - they are explicitly denied if any `"deny"` statements are found.
 *  - **`"deny"` statements trump `"allow"` statements.**
 *
 * @see https://rsinger86.github.io/drf-access-policy/policy_logic/
 */
export function resolveAccessPolicyStatementConditions(
  statements: AccessPolicyStatement[] | void,
  conditionEvaluator: AccessPolicyConditionEvaluator,
): ACCESS_POLICY_EFFECT {
  if (!statements || statements.length === 0) {
    return ACCESS_POLICY_EFFECT.DENY;
  }

  for (const statement of statements) {
    // because statements are pre-sorted by server,
    // "deny" rules are resolved first, so behavior match documentation.
    // intersect_conditions are evaluated first

    if (
      !statement.intersect_conditions ||
      !statement.intersect_conditions.length ||
      // intersect_conditions in array = AND
      statement.intersect_conditions.every(conditionEvaluator)
    ) {
      if (
        !statement.conditions ||
        !statement.conditions.length ||
        // conditions in array = OR
        statement.conditions.some(conditionEvaluator)
      ) {
        return statement.effect;
      }
    }
  }

  return ACCESS_POLICY_EFFECT.DENY;
}
